'use strict';
const angular = require('angular');

export class userCardComponent {
  /*@ngInject*/
  constructor() {
  }

  getPrimaryEmail(owner) {
    if (!owner || !owner.email || !owner.email.length)
      return "-";

    let email = owner.email.find(email => email.isPrimary) || owner.email[0] || {address:'-'};

    return email.address;
  }

  getPrimaryPhone(owner) {
    if (!owner || !owner.phone || !owner.phone.length)
      return "-";

    let phone = owner.phone.find(phone => phone.isPrimary) || owner.phone[0] || {number:'-'};

    return phone.number;
  }

  getPrimaryAddress(owner) {
    if (!owner || !owner.address || !owner.address.length)
      return "-";

    let address = owner.address.find(adr => adr.isPrimary) || owner.address[0] || {};

    let adrString = [];

    adrString.push(address.street);
    if (address.street2)
      adrString.push(address.street2);
    adrString.push(address.city + ' ' + address.state + ', ' + address.zip);
    if (address.country)
      adrString.push(address.country);

    return adrString.join(', ');
  }

  getPrimaryOwnerName() {
    let primary = this.property.contacts.find(contact => contact.type == 'primary-owner');

    if (!primary)
      return "-";

    /*
    let name = primary.contact.firstName;
    if (primary.contact.middleName)
      name += " " + primary.contact.middleName;
    name += " " + primary.contact.lastName;*/

    return this.getComposedName(primary.contact);
  }

  getPrimaryOwnerId() {
    let primary = this.property.contacts.find(contact => contact.type == 'primary-owner');

    if (!primary || !primary.contact)
      return 0;

    return primary.contact._id;
  }

  getPrimaryOwner() {
    let primary = this.property.contacts.find(contact => contact.type == 'primary-owner');

    if (!primary)
      return null;

    return primary.contact;
  }

  getComposedName(contact) {
    let composedName = "";

    if (contact.lastName && contact.firstName) {
      composedName = contact.lastName + ", " + contact.firstName;
      if (contact.middleName)
        composedName += " " + contact.middleName;
    }

    if (contact.company) {
      if (composedName == "")
        composedName += contact.company;
      else
        composedName += "<br/>" + contact.company;
    }

    return composedName || "-";
  }
}

export default angular.module('conduuApp.userCard', [])
  .component('userCard', {
    template: require('./user-card.component.html'),
    bindings: {
      community: '<',
      property: '<'
    },
    controller: userCardComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/user-card/user-card.component.js